module.exports = __webpack_public_path__ + "static/img/icon_dev_red.446fa2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_dev_red.png
// module id = C2oD
// module chunks = 1